// extracted by mini-css-extract-plugin
export default {"zoomModal":"r1-z","image":"s1-z","button":"t1-z","isOverlayShown":"u1-z"};